export enum LinkRunStatus {
    unknown = 0,
    undefined = 1,
    active  = 2,
    inactive = 3,
}